<template>
  <div>
    <AddEditStepDialog :method="method"
                       :selected-step-id="selectedStepId"
                       v-model="isAddEditStepDialogVisible"
                       @getSteps="getSequenceStepsService()"/>

    <NewEditSequence method="edit"
                     :selected-sequence-id="$route.params.sequenceId"
                     v-model="isEditSequenceDialogVisible"
                     @getSequence="getSequence()" />

    <template v-if="loadingSequence">
      <LoadingComponent :message="$t('general.loadingSequence')" />
    </template>

    <template v-else>
      <v-row justify="center">
        <v-col cols="12"
               class="d-flex justify-space-between align-center px-6">
          <h3 class="kbDarkBlueText--text text-uppercase">
            {{ selectedSequence.name }}
          </h3>

          <SequencePeopleAndStepsIndicators indicatorsColor="kbSemiLightGray" :sequence="selectedSequence" />

          <div class="d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="mainButtons"
                       class="mr-3"
                       height="40px"
                       icon
                       outlined
                       width="40px"
                       v-on="on"
                       @click="goToSequence()">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('general.goBackToTheSequence') }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab
                       color="mainButtons"
                       dark
                       small
                       v-on="on"
                       @click="showEditSequenceDialog()">
                  <v-icon color="white">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('general.editSequence') }}</span>
            </v-tooltip>
          </div>
        </v-col>

        <v-col cols="12">
          <v-divider />
        </v-col>

        <v-col class="d-flex flex-column align-center"
               cols="12"
               sm="6"
               md="3">
          <div>
            <span class="kbDarkBlueText--text d-block text-h6 font-weight-regular mb-4">
              {{ $t('general.sequenceStatus') }}
            </span>
            <div class="d-flex align-center">
              <v-icon :color="sequenceStatusColor(selectedSequence.status)"
                      class="pr-2"
                      x-small>
                mdi-circle
              </v-icon>
              <span class="kbSemiLightGrayText--text text-capitalize">
                {{ selectedSequence.status || 'Without status' }}
              </span>
            </div>
          </div>
        </v-col>

        <v-col class="d-flex flex-column align-center"
               cols="12"
               sm="6"
               md="3">
          <div>
            <span class="kbDarkBlueText--text d-block text-h6 font-weight-regular">
              {{ $t('general.isSequenceActive') }}
            </span>
            <v-switch color="kbBlue"
                      :input-value="selectedSequence.active"
                      @change="changeSequenceStatus($event, selectedSequence.id)" />
          </div>
        </v-col>

        <v-col class="d-flex flex-column align-center"
               cols="12"
               sm="6"
               md="3">
          <div>
            <span class="kbDarkBlueText--text d-block text-h6 font-weight-regular mb-4">
              {{ $t('general.creationDate') }}
            </span>
            <span class="kbSemiLightGrayText--text text-capitalize">
              {{ selectedSequence.createdAt | moment('MMMM Do YYYY') }}
            </span>
          </div>
        </v-col>

        <v-col class="d-flex flex-column align-center"
               cols="12"
               sm="6"
               md="3">
          <div>
            <span class="kbDarkBlueText--text d-block text-h6 font-weight-regular mb-4">
              {{ $t('general.lastEditionDate') }}
            </span>
            <span class="kbSemiLightGrayText--text text-capitalize">
              {{ selectedSequence.updatedAt | moment('MMMM Do YYYY') }}
            </span>
          </div>
        </v-col>

        <v-col cols="12">
          <v-divider />
        </v-col>

        <v-col cols="12" class="px-6">
          <span class="kbDarkBlueText--text d-block text-h5 font-weight-regular mb-4">
            {{ $t('general.sequenceSteps') }}
          </span>
          <StepsRow :allow-overflow="true"
                    @showAddStepDialog="showCreateStepDialog"
                    @showUpdateStepDialog="showUpdateStepDialog" />
        </v-col>

        <v-col cols="12">
          <v-divider />
        </v-col>

        <!--<v-col cols="12" md="6" class="px-6">
          <span class="kbDarkBlueText&#45;&#45;text
                       d-block
                       text-h5
                       font-weight-regular
                       mb-4">
            {{ $t('general.sequenceCompany') }}
          </span>
          <v-row no-gutters>
            <v-col cols="5">
              <template v-if="selectedSequence.companyImage && wasCompanyImageSuccessfullyLoaded">
                <v-img class="elevation-3"
                       alt="Company image"
                       :src="selectedSequence.companyImage"
                       style="border-radius: 50%"
                       @error="wasCompanyImageSuccessfullyLoaded = false"/>
              </template>

              <template v-else>
                <v-icon color="kbSemiLightGray"
                        size="200px">mdi-account-circle</v-icon>
              </template>
            </v-col>

            <v-col cols="7">
              <span class="kbSemiLightGrayText&#45;&#45;text d-block text-h6 font-weight-regular mb-4">
                Company name
              </span>
              <ul style="list-style: none">
                <li class="py-2">
                  <div class="d-flex align-center">
                    <v-icon color="kbBlue" class="mr-3">
                      mdi-email
                    </v-icon>
                    <span class="kbDarkBlueText&#45;&#45;text">
                      {{ selectedSequence.companyEmail || 'company@company.com' }}
                    </span>
                  </div>
                </li>

                <li class="py-2">
                  <div class="d-flex align-center">
                    <v-icon color="kbBlue" class="mr-3">
                      mdi-phone
                    </v-icon>
                    <span class="kbDarkBlueText&#45;&#45;text">
                      {{ selectedSequence.companyPhone || '+1 804 987 65 42' }}
                    </span>
                  </div>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-col>-->

        <!--<v-col cols="12" md="6" class="px-6">
          <span class="kbDarkBlueText&#45;&#45;text
                       d-block
                       text-h5
                       font-weight-regular
                       mb-4">
            {{ $t('general.sequenceOwner') }}
          </span>
          <v-row no-gutters>
            <v-col cols="5">
              <template v-if="selectedSequence.companyImage && wasCompanyImageSuccessfullyLoaded">
                <v-img class="elevation-3"
                       alt="Company image"
                       :src="selectedSequence.companyImage"
                       style="border-radius: 50%"
                       @error="wasCompanyImageSuccessfullyLoaded = false"/>
              </template>

              <template v-else>
                <v-icon color="kbSemiLightGray"
                        size="200px">mdi-account-circle</v-icon>
              </template>
            </v-col>

            <v-col cols="7">
              <span class="kbSemiLightGrayText&#45;&#45;text d-block text-h6 font-weight-regular mb-4">
                Owner name
              </span>
              <ul style="list-style: none">
                <li class="py-2">
                  <div class="d-flex align-center">
                    <v-icon color="kbBlue" class="mr-3">
                      mdi-email
                    </v-icon>
                    <span class="kbDarkBlueText&#45;&#45;text">
                      {{ selectedSequence.ownerEmail || 'owner@owner.com' }}
                    </span>
                  </div>
                </li>

                <li class="py-2">
                  <div class="d-flex align-center">
                    <v-icon color="kbBlue" class="mr-3">
                      mdi-phone
                    </v-icon>
                    <span class="kbDarkBlueText&#45;&#45;text">
                      {{ selectedSequence.ownerPhone || '+1 804 987 65 42' }}
                    </span>
                  </div>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-col>-->
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'vue-moment'
import notifications from '@/libs/notifications'
import LoadingComponent from '@/components/ui/LoadingComponent'
import SequencePeopleAndStepsIndicators from '@/pages/App/Sequences/SequencePeopleAndStepsIndicators'
import StepsRow from '@/pages/App/Sequences/Steps/StepsRow'
import NewEditSequence from '@/pages/App/Sequences/dialogs/NewEditSequence'
import AddEditStepDialog from '@/pages/App/Sequences/Steps/dialogs/AddEditStep'
export default {
  components: { AddEditStepDialog, NewEditSequence, LoadingComponent, SequencePeopleAndStepsIndicators, StepsRow },
  computed: {
    ...mapState({
      selectedSequence: state => state.sequences.selectedSequence
    })
  },
  created () {
    if (!this.selectedSequence ||
        !Object.keys(this.selectedSequence).length ||
        this.$route.params.sequenceId !== this.selectedSequence.id) {
      this.getSequence()
    }
  },
  data () {
    return {
      isEditSequenceDialogVisible: false,
      isAddEditStepDialogVisible: false,
      loadingSequence: false,
      method: 'create',
      moment,
      changingSequenceStatus: false,
      selectedStepId: '',
      wasCompanyImageSuccessfullyLoaded: true,
      wasOwnerImageSuccessfullyLoaded: true
    }
  },
  methods: {
    changeSequenceStatus (active) {
      !active ? this.stopSequence() : this.runSequence()
    },
    async getSequence () {
      try {
        this.loadingSequence = true
        await Promise.all([
          this.getSequencePeople(),
          this.getSequenceService(),
          this.getSequenceStepsService()
        ])
        this.loadingSequence = false
      } catch (e) {
        this.loadingSequence = false
        console.log(e)
        notifications.error(e)
      }
    },
    async getSequencePeople () {
      await this.$store.dispatch('getSequencePeople', {
        appId: this.$store.getters.appUuid,
        sequenceId: this.$route.params.sequenceId
      })
    },
    async getSequenceService () {
      await this.$store.dispatch('getSequence',
        {
          appId: this.$store.getters.appUuid,
          sequenceId: this.$route.params.sequenceId
        }
      )
    },
    async getSequenceStepsService () {
      await this.$store.dispatch('getSequenceSteps',
        {
          appId: this.$store.getters.appUuid,
          sequenceId: this.$route.params.sequenceId
        }
      )
    },
    goToSequence () {
      this.$router.push(
        {
          name: 'Sequence Leads',
          params: {
            appid: this.$store.getters.appUuid,
            sequenceId: this.$route.params.sequenceId
          }
        }
      )
    },
    async runSequence () {
      try {
        await this.$store.dispatch('runSequence', { sequenceId: this.$route.params.sequenceId })
        this.getSequenceService()
      } catch (e) {
        notifications.error(e)
      }
    },
    sequenceStatusColor (status) {
      switch (status) {
        case 'pending':
          return 'kbRed'
        case 'completed':
          return 'kbBlue'
        case 'onSchedule':
          return 'kbBlue'
        case 'delayed':
          return 'kbRed'
        default:
          return 'kbRed'
      }
    },
    showCreateStepDialog () {
      this.method = 'create'
      this.selectedStepId = ''
      this.isAddEditStepDialogVisible = true
    },
    showEditSequenceDialog () {
      this.isEditSequenceDialogVisible = true
    },
    showUpdateStepDialog (stepId) {
      this.method = 'edit'
      this.selectedStepId = stepId
      this.isAddEditStepDialogVisible = true
    },
    async stopSequence () {
      try {
        await this.$store.dispatch('stopSequence', { sequenceId: this.$route.params.sequenceId })
        this.getSequenceService()
      } catch (e) {
        notifications.error(e)
      }
    }
  }
}
</script>
